import {FC} from 'react';
//mui
import {Box, Link, Typography} from '@mui/material';
//icons
import {ReactComponent as LogoIcon} from '@icons/logo-text-white.svg';
//constants
import {BODY2, H4, SIGN_UP} from '@/utils/constants';
//enums
import {ROUTER_URL} from '@/utils/enums';
//styles
import {asideStepperStyle} from './AsideStepper.styles';
import VerticalStepper from './VerticalStepper';

const AsideStepper: FC = () => {
  return (
    <Box sx={asideStepperStyle.wrapper}>
      <Box style={asideStepperStyle.logo}>
        <LogoIcon />
      </Box>
      <Typography sx={asideStepperStyle.title} variant={H4}>
        {SIGN_UP}
      </Typography>

      <VerticalStepper />

      <Box sx={asideStepperStyle.footer}>
        <Typography sx={asideStepperStyle.link} variant={BODY2}>
          EventSimpli © 2023
        </Typography>
        <Link sx={asideStepperStyle.link} variant={BODY2} href={ROUTER_URL.ORGANIZATION_PRIVACY_POLICY}>
          Privacy Policy
        </Link>
        <Link sx={asideStepperStyle.link} variant={BODY2} href={ROUTER_URL.ORGANIZATION_TERMS_AND_CONDITIONS}>
          Terms & Conditions
        </Link>
      </Box>
    </Box>
  );
};

export default AsideStepper;
